function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _omit from 'lodash/omit';
import { getValidElementProps } from '../utils/htmlValidProps';
import Label from '../Label';

require('xps-style/core/input.css');

require('xps-style/core/xps-style.min.css');

var propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  lblRequired: PropTypes.bool,

  /** Controls the font size and padding size */
  size: PropTypes.oneOf(['large', 'small']).isRequired,

  /** Sets the number of text rows visible */
  rows: PropTypes.number,

  /** Sets the height in pixels (overrides rows) */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** The limit of characters allowed in the textarea */
  charLimit: PropTypes.number,

  /** An error message that can be connected to a validator and sent when the validator is triggered */
  error: PropTypes.string,

  /** Allows the user to continue typing after reaching the character limit. If true, you must ensure form submission is disabled if over the character limit */
  allowOverLimit: PropTypes.bool,

  /** An error message that can be sent when the user goes over the character limit, if allowOverLimit is true */
  overLimit: PropTypes.string,

  /** Allows you to enable or disable the resize function of the element (IE not supported) */
  resize: PropTypes.bool,
  onChangeValue: PropTypes.func,

  /** Display optional next to the label */
  optional: PropTypes.bool,

  /** Remove margin top above the input label */
  removeMarginTop: PropTypes.bool
};
var defaultProps = {
  allowOverLimit: false,
  resize: true,
  onChangeValue: function onChangeValue() {}
};

var Textarea = /*#__PURE__*/function (_Component) {
  _inherits(Textarea, _Component);

  var _super = _createSuper(Textarea);

  function Textarea() {
    _classCallCheck(this, Textarea);

    return _super.apply(this, arguments);
  }

  _createClass(Textarea, [{
    key: "render",
    value: function render() {
      var _cx;

      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          className = _this$props.className,
          label = _this$props.label,
          size = _this$props.size,
          rows = _this$props.rows,
          height = _this$props.height,
          value = _this$props.value,
          charLimit = _this$props.charLimit,
          allowOverLimit = _this$props.allowOverLimit,
          overLimit = _this$props.overLimit,
          error = _this$props.error,
          lblRequired = _this$props.lblRequired,
          description = _this$props.description,
          resize = _this$props.resize,
          onChangeValue = _this$props.onChangeValue,
          optional = _this$props.optional,
          removeMarginTop = _this$props.removeMarginTop;
      var labelId = id || name;
      var inputAdaProps = {
        'aria-invalid': !!error || !!overLimit,
        'aria-required': lblRequired,
        'aria-describedby': error || overLimit ? "".concat(labelId, "__error") : "".concat(labelId, "__description")
      };
      var componentProps = getValidElementProps('input', this.props);

      var mergedInputProps = _objectSpread(_objectSpread({}, componentProps), inputAdaProps);

      var inputProps = _omit(mergedInputProps, 'label');

      var fontSize = 'sm';
      var paddingSize = 'md';

      if (size === 'large') {
        fontSize = 'md';
        paddingSize = 'lg';
      }

      var ntClass = cx((_cx = {}, _defineProperty(_cx, "input__field font-".concat(fontSize, " padding-").concat(paddingSize), true), _defineProperty(_cx, 'input-skin', !error || !overLimit), _defineProperty(_cx, 'input-skin--error', error || overLimit), _defineProperty(_cx, 'verticalalign-bottom', true), _cx));
      var descClass = cx({
        input__info: true,
        'color-text': true
      });
      var errorClass = cx({
        input__info: true,
        'color-text--error': true
      });
      var lblClass = cx({
        'input__label-required__container': true,
        'input__label--no-margintop': removeMarginTop
      });
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, /*#__PURE__*/React.createElement("div", {
        className: lblClass
      }, label !== undefined ? /*#__PURE__*/React.createElement(Label, {
        name: labelId,
        text: label,
        className: "input__label",
        optional: !lblRequired && optional
      }) : null, charLimit || lblRequired ? /*#__PURE__*/React.createElement("span", {
        className: "input__label-required font-sm"
      }, lblRequired && 'Required', charLimit && lblRequired ? ' - ' : null, charLimit && "".concat(value.length, "/").concat(charLimit)) : null), /*#__PURE__*/React.createElement("textarea", _extends({
        id: labelId,
        className: ntClass,
        maxLength: !allowOverLimit ? charLimit : undefined,
        required: lblRequired,
        onChange: onChangeValue,
        rows: rows,
        style: {
          height: height,
          resize: !resize && 'none'
        }
      }, inputProps)), overLimit ? /*#__PURE__*/React.createElement("div", {
        role: "alert",
        className: errorClass,
        id: "".concat(labelId, "__error")
      }, overLimit) : null, error ? /*#__PURE__*/React.createElement("div", {
        role: "alert",
        className: errorClass,
        id: "".concat(labelId, "__error")
      }, error) : null, description && !error && !overLimit ? /*#__PURE__*/React.createElement("div", {
        id: "".concat(labelId, "__description"),
        className: descClass
      }, description) : null);
    }
  }]);

  return Textarea;
}(Component);

Textarea.propTypes = propTypes;
Textarea.defaultProps = defaultProps;
Textarea.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Textarea",
  "props": {
    "allowOverLimit": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Allows the user to continue typing after reaching the character limit. If true, you must ensure form submission is disabled if over the character limit"
    },
    "resize": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Allows you to enable or disable the resize function of the element (IE not supported)"
    },
    "onChangeValue": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "lblRequired": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "size": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'large'",
          "computed": false
        }, {
          "value": "'small'",
          "computed": false
        }]
      },
      "required": true,
      "description": "Controls the font size and padding size"
    },
    "rows": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Sets the number of text rows visible"
    },
    "height": {
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "Sets the height in pixels (overrides rows)"
    },
    "charLimit": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The limit of characters allowed in the textarea"
    },
    "error": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "An error message that can be connected to a validator and sent when the validator is triggered"
    },
    "overLimit": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "An error message that can be sent when the user goes over the character limit, if allowOverLimit is true"
    },
    "optional": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Display optional next to the label"
    },
    "removeMarginTop": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Remove margin top above the input label"
    }
  }
};
export default Textarea;